import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'Components';
import './NotImplementedModal.css';

const NotImplementedModal = ({ show, onClose, text }) => (
  <div className="not-implemented-modal">
    <Modal show={show}>
      <div className="not-implemented-modal__content">
        <Button onClick={onClose}>
          <span>Close</span>
        </Button>
        <div>This has not been implemented yet {text}</div>
      </div>
    </Modal>
  </div>
);

NotImplementedModal.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string,
  onClose: PropTypes.func,
};

NotImplementedModal.defaultProps = {
  text: '',
};

export default NotImplementedModal;



// WEBPACK FOOTER //
// ./src/components/NotImplementedModal/NotImplementedModal.jsx